import React, { SVGProps } from 'react';

const CustomSuccess = (props: SVGProps<SVGSVGElement>) => (
	<svg width="91" height="92" viewBox="0 0 91 92" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M30.3335 47.8958L41.7085 59.2708L60.6668 36.5208" stroke="#90EE90" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M45.5002 83.9166C66.441 83.9166 83.4168 66.9408 83.4168 46C83.4168 25.0592 66.441 8.08331 45.5002 8.08331C24.5594 8.08331 7.5835 25.0592 7.5835 46C7.5835 66.9408 24.5594 83.9166 45.5002 83.9166Z" stroke="#90EE90" strokeWidth="2"/>
</svg>
);

export default CustomSuccess;
